import { Controller } from "@hotwired/stimulus"

// Управляет страницей добавления нового мессенджер-аккаунта.
// Обрабатывает выбор типа мессенджера и показ/скрытие соответствующих форм.
// Использует Stimulus вместо DOMContentLoaded для корректной работы с Turbo Drive.
export default class extends Controller {
  static targets = ["selection", "telegramForm", "whatsappPersonalForm", "max2Form", "maxbotForm", "vkgroupForm"]

  connect() {
    // Восстановить состояние, если форма показана с ошибками (после POST с ошибкой)
    this.restoreFormState()
  }

  // Выбор мессенджера — обработчик клика на карточку
  selectMessenger(event) {
    const card = event.currentTarget
    const messenger = card.dataset.messenger
    this.showForm(messenger)
  }

  // Показать форму нужного мессенджера
  showForm(messenger) {
    this.selectionTarget.style.display = "none"

    this.telegramFormTarget.style.display = "none"
    this.whatsappPersonalFormTarget.style.display = "none"
    this.max2FormTarget.style.display = "none"
    this.maxbotFormTarget.style.display = "none"
    this.vkgroupFormTarget.style.display = "none"

    if (messenger === "telegram") {
      this.telegramFormTarget.style.display = "flex"
    } else if (messenger === "whatsapp-personal") {
      this.whatsappPersonalFormTarget.style.display = "flex"
    } else if (messenger === "max2") {
      this.max2FormTarget.style.display = "flex"
    } else if (messenger === "maxbot") {
      this.maxbotFormTarget.style.display = "flex"
    } else if (messenger === "vkgroup") {
      this.vkgroupFormTarget.style.display = "flex"
    }
  }

  // Вернуться к выбору мессенджера (кнопка встречается в формах)
  showSelection() {
    this.selectionTarget.style.display = "flex"
    this.telegramFormTarget.style.display = "none"
    this.whatsappPersonalFormTarget.style.display = "none"
    this.max2FormTarget.style.display = "none"
    this.maxbotFormTarget.style.display = "none"
    this.vkgroupFormTarget.style.display = "none"
  }

  // При наличии ошибок в форме — показать нужный раздел (определяем по hidden field)
  restoreFormState() {
    const hasTelegramErrors = this.telegramFormTarget.querySelector('.alert-danger')
    const hasWhatsappErrors = this.whatsappPersonalFormTarget.querySelector('.alert-danger')
    const hasMax2Errors = this.max2FormTarget.querySelector('.alert-danger')
    const hasMaxbotErrors = this.maxbotFormTarget.querySelector('.alert-danger')
    const hasVkgroupErrors = this.vkgroupFormTarget.querySelector('.alert-danger')

    if (hasTelegramErrors) {
      this.showForm("telegram")
    } else if (hasWhatsappErrors) {
      this.showForm("whatsapp-personal")
    } else if (hasMax2Errors) {
      this.showForm("max2")
    } else if (hasMaxbotErrors) {
      this.showForm("maxbot")
    } else if (hasVkgroupErrors) {
      this.showForm("vkgroup")
    }
  }
}
